export default "__VITE_ASSET__BNxRVdue__";